import { render } from "./vipDetails.vue?vue&type=template&id=4c0f4ffe&scoped=true"
import script from "./vipDetails.vue?vue&type=script&lang=js"
export * from "./vipDetails.vue?vue&type=script&lang=js"

import "./vipDetails.vue?vue&type=style&index=0&id=4c0f4ffe&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0f4ffe"]])

export default __exports__